<div
  class="sub-nav-item"
  (click)="navItemSelected(); $event.stopPropagation()"
  [class.sub-active]="viewModel.isNavItemActive$ | async">
  {{ subItem?.name }}
</div>
